window.hoculus = window.hoculus || {};
if (console && console.log) {
	console.log(
		"Coded by %cHoculus srl %con %cShopify %c- %c" +
		Shopify.theme.name +
		" %c -> https://hoculus.com",
		"color: red; font-weight: bold",
		"color: unset",
		"color: green",
		"color: unset",
		"color: blue",
		"color: unset; font-weight: bold"
	);
}

hoculus.utils = class {
	static setCookie(name,value,minutes){
		var expires = "";
		if (minutes) {
				var date = new Date();
				date.setTime(date.getTime() + (minutes*60*1000));
				expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	};
	static getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
	};
    static async domreadyState() {
		return await new Promise(function (resolve, reject) {
			document.onreadystatechange = () => {
				if (document.readyState === "complete") resolve(true);
			};
		});
	}
	static onInteraction() {
		hoculus.interacted = hoculus.interacted || false;
		if (hoculus.interacted == false) {
			console.log("Interacted");
			["click", "scroll", "touchstart", "mousemove"].forEach(function (evt) {
				document.removeEventListener(evt, hoculus.utils.onInteraction)
			})
			hoculus.onInteractionCallback();
			hoculus.interacted = true;
		}
	}
}

// --- START ---
// This function is called when the user interacts with the page for the first time
hoculus.onInteractionCallback = function () {
	if (!(hoculus.theme.settings.tracking.clarity && window.Shopify.theme.role == 'main')) return;
	// FIP 2026-10: Clarity si carica solo con consenso "analytics" (GDPR)
	const loadClarity = () => {
		if (hoculus.clarityLoaded) return;
		hoculus.clarityLoaded = true;
		hoculus.clarity(window, document, "clarity", "script", "nvfqsoefbu");
	};
	const privacy = window.Shopify && window.Shopify.customerPrivacy;
	if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed()) {
		loadClarity();
	} else {
		document.addEventListener('visitorConsentCollected', (evt) => {
			if (evt.detail && evt.detail.analyticsAllowed) loadClarity();
		});
	}
}
// --- END ---

hoculus.customInvoice = class extends HTMLElement {
	selectors = {
		vat: "#hoculus-custom-invoice-vat",
		sdi: "#hoculus-custom-invoice-sdi",
	}

	constructor() {
		super();
		this.data = {
			hoculusCustomInvoiceVat: this.querySelector(this.selectors.vat),
			hoculusCustomInvoiceSdi: this.querySelector(this.selectors.sdi)
		};
		this.details = this.querySelector("details");
	}

	connectedCallback() {
		for (const [k,v] of Object.entries(this.data)) {
			v.value = hoculus.utils.getCookie(k);
			v.addEventListener("input", this.onInput.bind(this, k, v))
			v.addEventListener("invalid", () => {
				this.details.open = true
			})
		}
		this.checkRequired()
	}

	onInput(name, element) {
		hoculus.utils.setCookie(name, element.value);
		this.checkRequired()
	}

	checkRequired() {
		var requiredFields = false
		// check for non empty fields
		for (const [k, v] of Object.entries(this.data)) {
			if(v.value != ''){
				requiredFields =  true;
				break;
			}
		}
		// if any, make all fields required
		for (const [k, v] of Object.entries(this.data)) {
			const label = v.nextElementSibling || v.previousElementSibling

			if (requiredFields) {
				label.textContent = label.textContent.replace('*', '')
				v.required = true
				label.textContent = '*' + label.textContent
			} else {
				v.required = false
				label.textContent = label.textContent.replace('*', '')
				v.placeholder = ""
			}
		}
	}
};

// Compare Drawer
hoculus.CrossSellDrawer = class extends HTMLElement {
	compareDrawer = this.querySelector("compare-drawer");
	openCompareDrawer = this.querySelector(".js-open-compare-drawer");
	articlePagination = document.querySelector("article-pagination");
	articleId = this.dataset.articleId;

	constructor() {
		super();
		this.openCompareDrawer.classList.remove("is-out");

		// Show the drawer only if user has not already read the set article percentage
		if (hoculus.utils.getCookie(`article-id-${this.articleId}`) === this.articleId) return;

		const observer = new MutationObserver((mutationsList, observer) => {
			for (const mutation of mutationsList) {
			  if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
				const percentageRead = parseInt(window.getComputedStyle(this.articlePagination).getPropertyValue('--pagination-percent'));
				const readPercentageTarget = window.hoculus.theme.settings.article.readingPercentage;

				if (percentageRead >= readPercentageTarget) {
					document.querySelector("compare-drawer").open(this.openCompareDrawer);
					hoculus.utils.setCookie(`article-id-${this.articleId}`, this.articleId, 60);
					observer.disconnect();
				}
			  }
			}
		  });
		observer.observe(this.articlePagination, { attributes: true, attributeFilter: ['style'] });
		this.openCompareDrawer.addEventListener("click", () => observer.disconnect());
	}
}


// Clarity
hoculus.clarity = function (c, l, a, r, i, block = false) {
	c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
	const t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
	if (block == true) {
		t.type = "text/plain";
		t.dataset.cookieType = "analytics";
	}
	const y = l.getElementsByTagName(r)[0];
	y.parentNode.insertBefore(t, y);
}

hoculus.utils.domreadyState().then(async () => {
	["click", "scroll", "touchstart", "mousemove"].forEach(evt => document.addEventListener(evt, hoculus.utils.onInteraction, false));

	customElements.define("hoculus-invoice-details", hoculus.customInvoice);
	customElements.define("hoculus-cross-sell-drawer", hoculus.CrossSellDrawer);
});